(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('.araco-product-quote-link');
    if (!link) return;
    const section = link.closest('.shopify-section');
    const component = section?.querySelector('product-form-component[data-product-id="' + link.dataset.quoteProduct + '"]');
    const variant = component?.querySelector('input[name="id"]')?.value;
    const quantity = component?.querySelector('input[name="quantity"]')?.value;
    const url = new URL(link.href);
    if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
    if (quantity && Number.isInteger(Number(quantity)) && Number(quantity) > 0) url.searchParams.set('quantity', quantity);
    link.href = url.toString();
  });
  } catch(e) { console.error(e); }
})();

})();
